<div class="d-flex">
    @if (!mobile) {
        <div cdkMenuBar>
            @if (showHelpIcon) {
                <button (click)="openHelp()" mat-icon-button cdkMenuItem>
                    <mat-icon fontSet="far" fontIcon="fa-lightbulb"></mat-icon>
                </button>
            }

            @if (viewModel.manageMenu) {
                <button
                    [cdkMenuTriggerFor]="manageMenu"
                    mat-icon-button
                    cdkMenuItem
                    matTooltip="Beheer"
                    matTooltipPosition="below">
                    <mat-icon fontSet="far" fontIcon="fa-gear" />
                </button>
            }

            @if (viewModel.exportMenu) {
                <button
                    class="has-notification-dot"
                    [cdkMenuTriggerFor]="exportMenu"
                    mat-icon-button
                    cdkMenuItem
                    matTooltip="Exporteren"
                    matTooltipPosition="below">
                    <mat-icon fontSet="far" fontIcon="fa-file-arrow-down" />
                    @if (
                        (Functionalities.ChecklistSignOff | hasFunctionality) &&
                        checklistSignOffService.hasPendingSignOff()
                    ) {
                        <span class="notification-dot notification-dot--warning"></span>
                    }
                </button>
            }

            @if (viewModel.hoursMenu) {
                <button
                    [cdkMenuTriggerFor]="hoursMenu"
                    mat-icon-button
                    cdkMenuItem
                    matTooltip="Uren"
                    matTooltipPosition="below">
                    <mat-icon fontSet="far" fontIcon="fa-clock-two-thirty" />
                </button>
            }

            @if (viewModel.planningMenu) {
                <button
                    [cdkMenuTriggerFor]="planningMenu"
                    mat-icon-button
                    cdkMenuItem
                    matTooltip="Planning"
                    matTooltipPosition="below">
                    <mat-icon fontSet="far" fontIcon="fa-calendar-days" />
                </button>
            }

            <button
                class="has-notification-dot"
                [cdkMenuTriggerFor]="personMenu"
                mat-icon-button
                cdkMenuItem
                matTooltip="Mijn account / Overig"
                matTooltipPosition="below">
                <mat-icon fontSet="far" fontIcon="fa-user" />
                @if (codaltModusService.overallSeverity()) {
                    <span
                        class="notification-dot"
                        [class.notification-dot--error]="codaltModusService.overallSeverity() === 'error'"
                        [class.notification-dot--warning]="codaltModusService.overallSeverity() === 'warning'"></span>
                }
            </button>

            @if (!searchExpanded && viewModel.search) {
                <button (click)="onSearchFocus()" mat-icon-button matTooltip="Zoeken" matTooltipPosition="below">
                    <mat-icon fontSet="far" fontIcon="fa-sparkles" />
                </button>
            }
        </div>
    }

    @if (viewModel.search) {
        <div class="search-input" [class.loading]="searchLoading" [class.expanded]="searchExpanded">
            <input
                id="global-search"
                #searchInput
                [matAutocomplete]="auto"
                [formControl]="fcSearch"
                (keydown.escape)="onKeyDown($event)"
                (blur)="onSearchBlur()"
                matInput
                type="text" />

            <mat-autocomplete
                #auto="matAutocomplete"
                [panelWidth]="350"
                (optionSelected)="navigateSearch($event)"
                autoActiveFirstOption>
                @if (searchOptions?.length === 0 && searchExpanded) {
                    <mat-option disabled>Geen resultaten gevonden</mat-option>
                }

                @for (searchOption of searchOptions; track searchOption.path) {
                    <mat-option [value]="searchOption">
                        <div class="d-flex align-items-center">
                            <i class="fa-solid fa-link me-3"></i>
                            <div>
                                @if (searchOption.data.searchName) {
                                    {{ searchOption.data.searchName(searchOption) }}
                                } @else {
                                    {{ searchOption.path }}
                                }
                                <br />

                                @if (searchOption.subtitle) {
                                    <small>{{ searchOption.subtitle }}</small>
                                }

                                @if (searchOption.user) {
                                    <small
                                        class="me-1"
                                        [class.text-decoration-line-through]="searchOption.user?.deleted_at">
                                        {{ searchOption.user?.name }}</small
                                    >
                                    <small class="text-grey">{{ searchOption.user?.afas_employee_id }}</small>
                                }

                                @if (searchOption.projectId) {
                                    <small>{{ searchOption.projectId }}</small>
                                }
                            </div>
                        </div>
                    </mat-option>
                }
            </mat-autocomplete>
        </div>
    }

    @if (mobile) {
        <div cdkMenuBar>
            @if (showHelpIcon) {
                <button (click)="openHelp()" mat-icon-button cdkMenuItem>
                    <mat-icon fontSet="far" fontIcon="fa-lightbulb"></mat-icon>
                </button>
            }
            <button
                class="has-notification-dot"
                [cdkMenuTriggerFor]="mobileMenu"
                (cdkMenuOpened)="open = true"
                (cdkMenuClosed)="open = false"
                mat-icon-button
                cdkMenuItem>
                @if (!open) {
                    <mat-icon fontSet="far" fontIcon="fa-bars" />
                }

                @if (open) {
                    <mat-icon fontSet="far" fontIcon="fa-xmark" />
                }

                @if (
                    !open &&
                    (Functionalities.ChecklistSignOff | hasFunctionality) &&
                    checklistSignOffService.hasPendingSignOff()
                ) {
                    <span class="notification-dot notification-dot--warning"></span>
                }
            </button>
        </div>
    }
</div>

<ng-template #manageMenu>
    <div class="menu list" cdkMenu>
        <ng-container *ngTemplateOutlet="manageMenuContent"></ng-container>
    </div>
</ng-template>

<ng-template #exportMenu>
    <div class="menu list" cdkMenu>
        <ng-component *ngTemplateOutlet="exportMenuContent"></ng-component>
    </div>
</ng-template>

<ng-template #hoursMenu>
    <div class="menu list" cdkMenu>
        <ng-component *ngTemplateOutlet="hoursMenuContent"></ng-component>
    </div>
</ng-template>

<ng-template #planningMenu>
    <div class="menu list" cdkMenu>
        <ng-component *ngTemplateOutlet="planningMenuContent"></ng-component>
    </div>
</ng-template>

<ng-template #personMenu>
    <div class="menu list" cdkMenu>
        <ng-container *ngTemplateOutlet="personMenuContent"></ng-container>
    </div>
</ng-template>

<ng-template #mobileMenu>
    <div class="holder">
        <div class="menu mobile-menu list" cdkMenu>
            <i class="fa-regular fa-times me-2 close-btn" (click)="closeMobileMenu()"></i>
            <div class="mobile-menu-filters">
                <ng-content select="[menu-filters]"></ng-content>
            </div>

            @if (showPlanningFilter) {
                <app-planning-filter [mobile]="true" (selectedTeams)="selectedTeams.emit($event)"></app-planning-filter>
            }
            <ng-container *ngTemplateOutlet="personMenuContent"></ng-container>
            @if (viewModel.exportMenu) {
                <ng-container *ngTemplateOutlet="exportMenuContent"></ng-container>
            }

            @if (viewModel.manageMenu) {
                <ng-container *ngTemplateOutlet="manageMenuContent"></ng-container>
            }

            @if (viewModel.hoursMenu) {
                <ng-container *ngTemplateOutlet="hoursMenuContent"></ng-container>
            }

            @if (viewModel.planningMenu) {
                <ng-container *ngTemplateOutlet="planningMenuContent"></ng-container>
            }

            <ng-container *ngTemplateOutlet="personMenuContent"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #manageMenuContent>
    <div>Beheer</div>

    @if (viewModel.onlyCodalt) {
        <a routerLink="/rechtenmatrix">Rechtenmatrix</a>
        <a routerLink="/codalt/apparaten">Apparaten</a>
    }

    @if (viewModel.manageUsers) {
        <a routerLink="/gebruikers">Gebruikers</a>
    }

    @if (viewModel.manageEntities) {
        <a (click)="entities()">Materieel</a>
    }

    @if (viewModel.manageAsphalt) {
        <a (click)="asphalt()">Asfalt</a>
    }

    @if (viewModel.manageHiringCompanies) {
        <a (click)="hiringCompanies()">Inhuur bedrijven</a>
    }

    @if (viewModel.manageToolbox) {
        <a (click)="toolbox()">Toolboxen beheren</a>
    }

    @if (viewModel.manageProjects) {
        <a routerLink="/projects">Projecten</a>
    }

    @if (viewModel.manageClients) {
        <a routerLink="/opdrachtgevers">Opdrachtgeversbeheer</a>
    }

    @if (viewModel.manageTickets) {
        <a routerLink="/tickets">KAM-meldingen</a>
    }

    @if (viewModel.manageChecklists) {
        <a routerLink="/checklists/types">Inspectiesoorten</a>
    }

    @if (viewModel.manageArticles) {
        <a routerLink="/bestekprijzen">Besteksprijzen</a>
    }
    @if (viewModel.manageMaterials) {
        <a routerLink="/materiaalbeheer">Materiaalbeheer</a>
    }
    @if (viewModel.manageUsers) {
        <a routerLink="/crm-functies">CRM functies</a>
    }

    @if (viewModel.orderdirect) {
        <a routerLink="/orderdirect-facturen">OD verkoopfacturen</a>
        <a routerLink="/orderdirect-inkoopfacturen">OD inkoopfacturen</a>
    }
</ng-template>

<ng-template #hoursMenuContent>
    <div>Uren</div>

    @if (viewModel.checkHours) {
        <a routerLink="/check-hours/{{ date | date: 'yyyy-MM-dd' }}">Urencontrole</a>
    }

    @if (viewModel.generalHourCheck) {
        <a routerLink="/dagcontrole/{{ date | date: 'yyyy-MM-dd' }}">Dagcontrole</a>
    }

    @if (viewModel.generalHourCheck) {
        <a routerLink="/weekcontrole/{{ date | date: 'yyyy' }}/{{ date | date: 'w' }}">Weekcontrole</a>
    }

    @if (viewModel.projectWeekReport) {
        <a routerLink="/project-rapport/{{ projectId ?? 'null' }}/{{ date | date: 'w' }}/{{ date | date: 'yyyy' }}"
            >Weekrapport</a
        >
    }

    @if (viewModel.projectDayReport) {
        <a routerLink="/project-dagrapport/{{ projectId ?? 'null' }}/{{ date | date: 'yyyy-MM-dd' }}">Dagrapport</a>
    }

    @if (viewModel.settlementsAndAfas) {
        <div>Verloning</div>
    }

    @if (viewModel.settlementsAndAfas) {
        <a routerLink="/periodeverrekening">Periodeverrekening</a>
    }

    @if (viewModel.settlementsAndAfas) {
        <a routerLink="/boekingsregels">Boekingsregels</a>
    }

    @if (viewModel.settlementsAndAfas) {
        <a routerLink="/boekingsregels-versturen">Alle boekingsregels</a>
    }

    @if (viewModel.settlementsAndAfas) {
        <a routerLink="/settlements">Afas nacalculatie</a>
    }

    @if (viewModel.leave) {
        <a routerLink="/leave">Verlof</a>
    }
</ng-template>

<ng-template #personMenuContent>
    <div>Mijn account</div>

    <a class="user" (click)="openProfile()">
        <i class="fa-regular fa-user"></i> {{ authenticatedUser?.name }}<br />
        <i class="fa-regular fa-envelope"></i> {{ authenticatedUser?.email }}<br />
    </a>

    @if (viewModel.hourRegistration) {
        <a routerLink="/hours/{{ date | date: 'yyyy-MM-dd' }}">Urenregistratie</a>
    }

    @if (viewModel.periodSettlement) {
        <a routerLink="/periodeverrekening">Periodeverrekening</a>
    }

    <a (click)="logout()">Uitloggen</a>

    @if (viewModel.codaltMode) {
        <div>Codalt modus</div>
        <a (click)="toggleCodaltMode()">
            <i
                class="fa-regular me-2"
                [class.fa-toggle-on]="codaltModusService.enabled()"
                [class.fa-toggle-off]="!codaltModusService.enabled()"></i>
            {{ codaltModusService.enabled() ? 'Ingeschakeld' : 'Uitgeschakeld' }}
        </a>

        @if (Features.CodaltDump | hasFeature) {
            <a (click)="downloadSqlFile()">
                <i class="fa-regular me-2 fa-database"></i>
                DB Dump
            </a>
        }

        @if (Functionalities.CodaltLogViewer | hasFunctionality) {
            <a [routerLink]="['/codalt/logs', todayDate]">
                <i class="fa-regular me-2 fa-file-lines"></i>
                Logbestanden
                @if (codaltModusService.logsSeverity()) {
                    <span
                        class="menu-dot"
                        [class.menu-dot--error]="codaltModusService.logsSeverity() === 'error'"
                        [class.menu-dot--warning]="codaltModusService.logsSeverity() === 'warning'"></span>
                }
            </a>
        }

        @if (Functionalities.CodaltFailedJobs | hasFunctionality) {
            <a routerLink="/codalt/failed-jobs">
                <i class="fa-regular me-2 fa-triangle-exclamation"></i>
                Failed Jobs
                @if (codaltModusService.failedJobsSeverity()) {
                    <span class="menu-dot menu-dot--error"></span>
                }
            </a>
        }

        @if (Functionalities.CodaltAppLogs | hasFunctionality) {
            <a [routerLink]="['/codalt/app-logs', todayDate]">
                <i class="fa-regular me-2 fa-mobile-screen"></i>
                App Logs
                @if (codaltModusService.appLogsSeverity()) {
                    <span class="menu-dot menu-dot--error"></span>
                }
            </a>
        }
    }

    <div>Overig</div>

    @if (viewModel.toolbox) {
        <a (click)="showToolbox()">Toolbox</a>
    }

    @if (viewModel.toolbox) {
        <a (click)="showPastToolboxes()">Oude toolboxen</a>
    }

    @if (viewModel.tickets) {
        <a routerLink="/tickets">KAM-meldingen</a>
        <a routerLink="/tickets/0"><i class="fa fa-triangle-exclamation me-2"></i> KAM melding maken</a>
    }
</ng-template>

<ng-template #planningMenuContent>
    <div>Planning</div>

    @if (viewModel.personalSchedule) {
        <a routerLink="/weekschedule">Persoonlijke planning</a>
    }

    @if (viewModel.asphaltPlanning) {
        <a routerLink="/">{{ environment.rootPageName }}</a>
    }

    @if (viewModel.staffing) {
        <a routerLink="/staffing">Bezetting</a>
    }

    @if (viewModel.yearPlanning) {
        <a routerLink="/jaarplanning">Jaarplanning materieel</a>
    }

    @if (viewModel.behoefteOverview) {
        <a routerLink="/behoefte">Behoefte</a>
    }

    @if (viewModel.inventarizePlanning) {
        <a routerLink="/inventarisatie">Inventarisatie</a>
    }

    @if (viewModel.transportPlanning) {
        <a routerLink="/transport-planning">Transportplanning</a>
    }

    @if (viewModel.employeePlanning) {
        <a routerLink="/personeelsplanning">Personeelsplanning</a>
    }

    @if (viewModel.executorsPlanning) {
        <a class="capital" routerLink="/project-executor-planning">{{ environment.executorNamePlural }}planning</a>
    }

    @if (viewModel.asphaltTeams) {
        <a routerLink="/asfaltploegen">Asfaltploegen</a>
    }

    @if (viewModel.vkm) {
        <a routerLink="/vkm-planning">VKM planning</a>
        <a routerLink="/vkm-werkorders">VKM werkorders</a>
    }
</ng-template>

<ng-template #exportMenuContent>
    <div>Exporteren</div>

    @if (viewModel.manageAsphalt) {
        <a (click)="exportAsphalt()">Bestellijst asfalt</a>
    }

    @if (viewModel.hirePeople) {
        <a (click)="hirePeople()">Inhuur mensen</a>
    }

    @if (viewModel.reportHiringCompanies) {
        <a (click)="hiredCompanies()">Ingehuurd materieel</a>
    }

    @if (viewModel.projectmanagerReport) {
        <a (click)="projectmanagerReport()">Projectleider rapport</a>
    }

    @if (viewModel.manageProjects) {
        <a routerLink="/projects-overview">Gecomb. weekrapporten</a>
    }

    @if (viewModel.aiReports) {
        <a routerLink="/ai/rapporten">AI rapporten</a>
    }

    @if (viewModel.checklists) {
        <a routerLink="/checklists">
            Inspecties
            @if ((Functionalities.ChecklistSignOff | hasFunctionality) && checklistSignOffService.hasPendingSignOff()) {
                <span class="menu-dot menu-dot--warning"></span>
            }
        </a>
    }

    @if (viewModel.manageDeclarations) {
        <a routerLink="/bestekprijzen/declaraties">Afrekeningen</a>
    }

    @if (viewModel.manageDeclarations) {
        <a
            [routerLink]="['/bestekprijzen/dagrapporten']"
            [queryParams]="customerIdFromUrl() ? { customerId: customerIdFromUrl() } : null">
            Dagrapporten verwerken
        </a>
    }

    @if (viewModel.pdfApplyBackgroundSave) {
        <a (click)="openPdfBackgroundDialog()">Briefpapier toevoegen</a>
    }
</ng-template>
